import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { routePath } from 'app/services/helpers'
import axios from 'app/services/http/axios';

// -------

import {Actions} from './slice';
import { Api } from 'modules/Admin/Accounts'

// -------

function* get({payload: {id}}) {
  try {
    const route = routePath(Api.account, { id })

    const response = yield call(axios.get, route);
    yield put(Actions.getUserSuccess(response));

  } catch (e) {
    return yield put(Actions.getUserFailed(e));
  }
}

function* getFilters() {
  try {
    const route = Api.formFilters;
    const response = yield call(axios.get, route);
    yield put(Actions.getFiltersSuccess(response));

  } catch (e) {
    return yield put(Actions.getFiltersFailed(e));
  }
}

function* save({ payload: {id, values} }) {

  console.log('id', id)
  console.log('values', values)

  try {

    if ( id === 0 ) id = 'create'
    const route = routePath(Api.account, { id })

    const response = yield call(axios.post, route, { ...values });
    yield put(Actions.saveFormSuccess(response));

    toast.success('Account has been successfully saved')

  } catch (e) {
    return yield put(Actions.saveFormFailed(e));
  }
}

export function* watchAccountsFormSaga() {
  yield takeLatest(Actions.getUser.type, get)
  yield takeLatest(Actions.getFilters.type, getFilters)
  yield takeLatest(Actions.saveForm.type, save)
}

export default watchAccountsFormSaga
